import { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiMenu, MenuProps } from '@mui/material/Menu';

const Menu: FunctionComponent<MenuProps> = (
  props: PropsWithChildren<MenuProps>
) => {
  return <MuiMenu {...props}>{props.children}</MuiMenu>;
};

export default Menu;
